import { render, staticRenderFns } from "./EditProduk.vue?vue&type=template&id=cfff41fc&"
import script from "./EditProduk.vue?vue&type=script&lang=js&"
export * from "./EditProduk.vue?vue&type=script&lang=js&"
import style0 from "./EditProduk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports